// extracted by mini-css-extract-plugin
export default {"medium":"transactions-tab_medium__pmrDr","small":"transactions-tab_small__ZvpBX","transaction":"transactions-tab_transaction__qMF+G"};